module.exports = __webpack_public_path__ + "img/konversta.654bb2bd.png";